import * as React from "react";
import { cn } from "../../lib/utils";

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "default" | "primary" | "secondary";
  isDark?: boolean;
  showArrow?: boolean;
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  function Button(
    {
      className,
      variant = "default",
      isDark = true,
      showArrow = false,
      children,
      ...props
    },
    ref,
  ) {
    const baseClasses =
      "group relative font-medium cursor-pointer pointer-events-auto press disabled:cursor-not-allowed";

    const variantClasses = {
      default: "disabled:opacity-50",
      primary:
        "w-full py-4 px-6 rounded-xl border-[3px] border-ink shadow-board bg-gold text-ink font-display text-lg hover:bg-[#ffd566] disabled:bg-gray-100 disabled:text-gray-500 disabled:hover:bg-gray-100",
      secondary: `w-full py-4 px-6 rounded-xl border-[3px] border-ink shadow-board font-display text-lg disabled:opacity-50 ${
        isDark
          ? "bg-zinc-900 text-white hover:bg-zinc-800"
          : "bg-white text-gray-900 hover:bg-gray-100"
      }`,
    };

    return (
      <button
        ref={ref}
        className={cn(baseClasses, variantClasses[variant], className)}
        {...props}
      >
        <span className="flex items-center justify-center gap-2">
          {children}
          {showArrow && (
            <svg
              className="w-4 h-4 transition-transform group-hover:translate-x-0.5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={3}
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              />
            </svg>
          )}
        </span>
      </button>
    );
  },
);

Button.displayName = "Button";
